import PropTypes from "prop-types";
import { Dialog, Typography, Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import DiscontinueIcon from "../../assets/Discontinue.svg";

const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "16px",
    width: "370px",
    maxWidth: "400px",
    backgroundColor: "#FFFFFF",
    padding: "24px",
    textAlign: "center",
  },
});

const IconContainer = styled(Box)({
  width: "64px",
  height: "64px",
  borderRadius: "50%",
  backgroundColor: "#FFF3F3",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 16px",
  "& svg": {
    color: "#F15B59",
    fontSize: "32px",
  },
});

const Title = styled(Typography)({
  fontSize: "20px",
  fontWeight: 600,
  color: "#1A1A1A",
  marginBottom: "8px",
});

const Description = styled(Typography)({
  fontSize: "14px",
  color: "#666666",
  marginBottom: "24px",
});

const ButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "12px",
  marginTop: "2px",
  width: "100%",
  "& > button": {
    flex: 1,
    maxWidth: "150px",
  },
});

const StyledButton = styled(Button)({
  textTransform: "none",
  width: "150px",
  height: "42px",
  fontSize: "14px",
  fontWeight: 500,

  borderRadius: "25px !important",
  "&.MuiButton-root": {
    borderRadius: "25px",
  },
  "&.MuiButton-outlined": {
    borderRadius: "25px",
  },
  "&.MuiButton-contained": {
    borderRadius: "25px",
  },
  "&.cancel": {
    border: "1px solid #E0E0E0",
    color: "#666666",
    "&:hover": {
      borderColor: "#BDBDBD",
      backgroundColor: "transparent",
    },
  },
  "&.confirm": {
    backgroundColor: "#F15B59",
    color: "#FFFFFF",
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.6)",
    "&:hover": {
      backgroundColor: "#E53935",
    },
  },
});

const DeleteRxModal = ({ open, onClose, onConfirm, isMultiple = false }) => {
  const handleConfirm = () => {
    onClose();
    if (onConfirm) onConfirm();
  };

  const dialogTitleId = "delete-task-dialog-title";
  const dialogDescriptionId = "delete-task-dialog-description";

  return (
    <StyledDialog 
      open={open} 
      onClose={onClose}
      aria-labelledby={dialogTitleId}
      aria-describedby={dialogDescriptionId}
      ModalProps={{
        keepMounted: false,
        disableEnforceFocus: false,
        disableAutoFocus: false,
        disableRestoreFocus: false,
      }}
    >
      <IconContainer>
        <img
          src={DiscontinueIcon}
          alt="Warning icon"
          style={{ width: "24px", height: "24px" }}
        />
      </IconContainer>
      <Title id={dialogTitleId}>Delete Task</Title>
      <Description
        id={dialogDescriptionId}
        sx={{
          fontWeight: 500,
          fontStyle: "Medium",
          fontSize: "18px",
          lineHeight: "32px",
          letterSpacing: "0%",
          textAlign: "center",
          color: "#4E4B44",
        }}
      >
        Are you sure you want to delete{" "}
        {isMultiple ? "these tasks" : "this task"}?
      </Description>
      <ButtonContainer>
        <StyledButton 
          variant="outlined" 
          className="cancel" 
          onClick={onClose}
          aria-label="Cancel delete task"
        >
          Cancel
        </StyledButton>
        <StyledButton
          variant="contained"
          className="confirm"
          onClick={handleConfirm}
          aria-label={`Yes, delete ${isMultiple ? 'tasks' : 'task'}`}
        >
          Yes, delete
        </StyledButton>
      </ButtonContainer>
    </StyledDialog>
  );
};


DeleteRxModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  isMultiple: PropTypes.bool,
};

export default DeleteRxModal;
